// src/services/categoriesAPI.ts
import { fetchWithAuth } from './auth';
import { API_BASE, STATIC_ORIGIN } from '../config';

export const STATIC_BASE = STATIC_ORIGIN;

// ── Categories ─────────────────────────────────────────────────────────────────

export type CategoryItem = {
  category_id: number;
  name: string;
  name_: string;
  img: string;
};

export async function getCategories(): Promise<CategoryItem[]> {
  const res = await fetch(`${API_BASE}/category`);
  if (!res.ok) throw new Error(`Ошибка загрузки категорий: ${res.status}`);
  return res.json();
}

export async function updateCategory(id: number, img: File): Promise<CategoryItem> {
  const fd = new FormData();
  fd.append('img', img);
  const res = await fetchWithAuth(`${API_BASE}/category/${id}`, { method: 'PATCH', body: fd });
  if (!res.ok) {
    const d = await res.json().catch(() => ({}));
    throw new Error((d as any).message ?? 'Ошибка при обновлении категории');
  }
  return res.json();
}

// ── Product brands (Bosch, NGK, etc.) ─────────────────────────────────────────

export type BrandItem = {
  id: number;
  name: string;
  image: string;
};

export async function getBrands(): Promise<BrandItem[]> {
  const res = await fetch(`${API_BASE}/brand`);
  if (!res.ok) throw new Error(`Ошибка загрузки брендов: ${res.status}`);
  return res.json();
}

export async function updateBrandImage(id: number, img: File): Promise<BrandItem> {
  const fd = new FormData();
  fd.append('img', img);
  const res = await fetchWithAuth(`${API_BASE}/brand/${id}`, { method: 'PATCH', body: fd });
  if (!res.ok) {
    const d = await res.json().catch(() => ({}));
    throw new Error((d as any).message ?? 'Ошибка при обновлении логотипа');
  }
  return res.json();
}

// ── Founders (О Нас — фото основателя/соучредителя) ───────────────────────────

export type FounderItem = {
  id: number;
  role: string;   // 'founder' | 'cofounder'
  name: string;
  image: string;
};

export async function getFounders(): Promise<FounderItem[]> {
  const res = await fetch(`${API_BASE}/founder`);
  if (!res.ok) throw new Error(`Ошибка загрузки основателей: ${res.status}`);
  return res.json();
}

export async function updateFounderImage(id: number, img: File): Promise<FounderItem> {
  const fd = new FormData();
  fd.append('img', img);
  const res = await fetchWithAuth(`${API_BASE}/founder/${id}`, { method: 'PATCH', body: fd });
  if (!res.ok) {
    const d = await res.json().catch(() => ({}));
    throw new Error((d as any).message ?? 'Ошибка при обновлении фото');
  }
  return res.json();
}
